/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import TableCell from "@mui/material/TableCell";

export interface MaxWidthTableCellProps {
    children: React.ReactNode;
    className?: string;
}

// Das SCSS der MaxWidthTableCell muss in der App importiert werden
export default function MaxWidthTableCell(props: MaxWidthTableCellProps) {
    return <TableCell className={`lan-maxwidthtablecell ${props.className}`}>{props.children}</TableCell>;
}
